import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { KioskLocation } from '../types/assign-kiosk-types';

export interface SaveSparkMappingResult {
  hasError: boolean;
  errorMessage?: string;
}

export class SaveSparkMappingUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(machineId: string, location: KioskLocation): Promise<SaveSparkMappingResult> {
    try {
      await this.repository.saveSparkMapping(machineId, location);
      return { hasError: false };
    } catch (error) {
      const errorMessage = 'Unknown error occurred';
      return { hasError: true, errorMessage };
    }
  }
}
